/**
 * Cookie utility functions
 */

const COOKIE_OPTIONS = {
  expires: 7, // 7 days
  secure: process.env.NODE_ENV === 'production', // Only send over HTTPS in production
  sameSite: 'strict' as const,
  path: '/',
};

export const cookieKeys = {
  token: 'auth_token',
  refreshToken: 'refresh_token',
} as const;

/**
 * Set a cookie
 */
export function setCookie(name: string, value: string, days: number = 7): void {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  
  let cookieString = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=${COOKIE_OPTIONS.path}`;
  
  if (COOKIE_OPTIONS.secure) {
    cookieString += '; secure';
  }
  
  cookieString += `; samesite=${COOKIE_OPTIONS.sameSite}`;
  
  document.cookie = cookieString;
}

/**
 * Get a cookie value
 */
export function getCookie(name: string): string | null {
  const nameEQ = name + '=';
  const cookies = document.cookie.split(';');
  
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1, cookie.length);
    }
    if (cookie.indexOf(nameEQ) === 0) {
      return decodeURIComponent(cookie.substring(nameEQ.length, cookie.length));
    }
  }
  return null;
}

/**
 * Delete a cookie
 */
export function deleteCookie(name: string): void {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${COOKIE_OPTIONS.path};`;
}

/**
 * Clear all auth cookies (tokens only, user is stored in Zustand)
 */
export function clearAuthCookies(): void {
  deleteCookie(cookieKeys.token);
  deleteCookie(cookieKeys.refreshToken);
}

